// Copyright (c) 2022 by Move Closer

import { ComputedRef, WritableComputedRef } from '@vue/composition-api'

import { AbstractInputControlProps } from '../../abstract/components/InputControl/InputControl.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl> (original)
 * @author Michał Rossian <michal.rossian@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export interface DateTimePickerProps extends AbstractInputControlProps<string> {
  /**
   * Defines the autocomplete prop for input.
   */
  autocomplete: string

  /**
   * Determines the default value.
   */
  defaultValue: string | Date

  /**
   * Determines the blockd (disabled) date callback
   *
   * @see DisabledDateCallback
   */
  disabledDate: DisabledDateCallback

  /**
   * Determines the formatting of date/time/datetime
   */
  format: string

  /**
   * Defines the type ofg the picker
   *
   * @see DateTimePickerType
   */
  pickerType: DateTimePickerType

  /**
   * Determines the range of selectable date.
   */
  range: boolean

  /**
   * Determines whether seconds should be shown.
   */
  showSecond: boolean

  /**
   * Determines whether week number should be shown.
   */
  showWeekNumber: boolean

  /**
   * Determines steps (range) of selecting date/time
   *
   * @see DateTimePickerSteps
   */
  steps: DateTimePickerSteps
}

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
export type DisabledDateCallback = (date: Date, currentValue: Date[]) => boolean

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface DateTimePickerSteps {
  hour?: number
  minute?: number
  second?: number
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum DateTimePickerType {
  Date = 'date',
  DateTime = 'datetime',
  Time = 'time'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface UseDateTimerPickerProvides {
  /**
   * Determines the steps setup.
   */
  stepsSetup: ComputedRef<DateTimePickerStepType>

  /**
   * Determines the synced model value for input
   */
  value: WritableComputedRef<string>
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type DateTimePickerStepType = { hourStep: number; minuteStep: number; secondStep: number }
